export default "__VITE_ASSET__1f5f04bf__"